import { Product } from 'models/product';

export const isProductNotFound = ({ product }: { product?: Product }): boolean => {
  const { images, isActive, isExcluded } = product || {};

  return (!isActive && !isExcluded) || !images || images.length === 0;
};
